import { render } from "./ComplaintForm.vue?vue&type=template&id=694d33ac"
import script from "./ComplaintForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/jbh/achievementManage/complaintManage/ComplaintForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "694d33ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('694d33ac', __exports__)) {
    console.log('reload')
    api.reload('694d33ac', __exports__)
  }
  
  module.hot.accept("./ComplaintForm.vue?vue&type=template&id=694d33ac", () => {
    console.log('re-render')
    api.rerender('694d33ac', render)
  })

}


export default __exports__